<template lang='pug'>
  el-card.ec-campaign-participant(v-loading="loading")
    .card-title {{ $t('参与人员') }}
    .participant-items(v-if='campaignUser && campaignUser.market.leader.length')
      .participant-item
        .title {{ $t('项目负责人') }}
        template(
          v-for='(item, index) in campaignUser.market.leader'
        )
          .inp_block(
            v-if="editIndex === index && group === 'market'"
          )
            el-select(
              v-model="inpObj.user_id"
              filterable
            )
              el-option(
                v-for="o, i in userList"
                :key="i"
                :value="o.user_id"
                :label="o.mail"
              )
            i.iconfont.icon-baocun(
              @click="updateCampaignUser('market', index)"
            )
          .content(
            v-if="group !== 'market' || (editIndex !== index && group === 'market')"
          )  {{ item.mail }}
            i.iconfont.icon-plan(v-if='campaignUser.market.can_edit' @click="showInput('market', index)")
    .participant-items(v-if='campaignUser')
      .participant-item(v-if='campaignUser.market_lv2 && campaignUser.market_lv2.leader.length && user.struct_group_name !== "PHD"')
        .title {{ $t('WL2 审批人') }}
        template(
          v-for='(item, index) in campaignUser.market_lv2.leader'
        )
          .inp_block(
            v-if="editIndex === index && group === 'market_lv2'"
          )
            el-select(
              v-model="inpObj.user_id"
              filterable
            )
              el-option(
                v-for="o, i in userList"
                :key="i"
                :value="o.user_id"
                :label="o.mail"
              )
            i.iconfont.icon-baocun(
              @click="updateCampaignUser('market_lv2', index)"
            )
          .content(
            v-if="group !== 'market_lv2' || (editIndex !== index && group === 'market_lv2')"
          )  {{ item.mail }}
            i.iconfont.icon-plan(v-if='campaignUser.market_lv2.can_edit' @click="showInput('market_lv2', index)")
      .participant-item(v-if='campaignUser.market_lv3 && campaignUser.market_lv3.leader.length && user.struct_group_name !== "TP" && user.struct_group_name !== "PHD"')
        .title {{ $t('WL3 审批人') }}
        template(
          v-for='(item, index) in campaignUser.market_lv3.leader'
        )
          .inp_block(
            v-if="editIndex === index && group === 'market_lv3'"
          )
            el-select(
              v-model="inpObj.user_id"
              filterable
            )
              el-option(
                v-for="o, i in userList"
                :key="i"
                :value="o.user_id"
                :label="o.mail"
              )
            i.iconfont.icon-baocun(
              @click="updateCampaignUser('market_lv3', index)"
            )
          .content(
            v-if="group !== 'market_lv3' || (editIndex !== index && group === 'market_lv3')"
          )  {{ item.mail }}
            i.iconfont.icon-plan(v-if='campaignUser.market_lv3.can_edit' @click="showInput('market_lv3', index)")
      .participant-item(v-if='campaignUser.ec && campaignUser.ec.leader.length && user.struct_group_name !== "PHD"')
        .title {{ $t('EC 审批人') }}
        template(
          v-for='(item, index) in campaignUser.ec.leader'
        )
          .inp_block(
            v-if="editIndex === index && group === 'ec'"
          )
            el-select(
              v-model="inpObj.user_id"
              filterable
            )
              el-option(
                v-for="o, i in userList"
                :key="i"
                :value="o.user_id"
                :label="o.mail"
              )
            i.iconfont.icon-baocun(
              @click="updateCampaignUser('ec', index)"
            )
          .content(
            v-if="group !== 'ec' || (editIndex !== index && group === 'ec')"
          )  {{ item.mail }}
            i.iconfont.icon-plan(v-if='campaignUser.ec.can_edit' @click="showInput('ec', index)")
      .participant-item(v-if='campaignUser.phd && campaignUser.phd.leader.length && user.struct_group_name !== "TP"')
        .title {{ $t('phd 负责人') }}
        template(
          v-for='(item, index) in campaignUser.phd.leader'
        )
          .inp_block(
            v-if="editIndex === index && group === 'phd'"
          )
            el-select(
              v-model="inpObj.user_id"
              filterable
            )
              el-option(
                v-for="o, i in userList"
                :key="i"
                :value="o.user_id"
                :label="o.mail"
              )
            i.iconfont.icon-baocun(
              @click="updateCampaignUser('phd', index)"
            )
          .content(
            v-if="group !== 'phd' || (editIndex !== index && group === 'phd')"
          )  {{ item.mail }}
            i.iconfont.icon-plan(v-if='campaignUser.phd.can_edit' @click="showInput('phd', index)")
      .participant-item(v-if='campaignUser.tp && campaignUser.tp.leader.length && user.struct_group_name !== "PHD"')
        .title {{ $t('TP 负责人') }}
        template(
          v-for='(item, index) in campaignUser.tp.leader'
        )
          .inp_block(
            v-if="editIndex === index && group === 'tp'"
          )
            el-select(
              v-model="inpObj.user_id"
              filterable
            )
              el-option(
                v-for="o, i in userList"
                :key="i"
                :value="o.user_id"
                :label="o.mail"
              )
            i.iconfont.icon-baocun(
              @click="updateCampaignUser('tp', index)"
            )
          .content(
              v-if="group !== 'tp' || (editIndex !== index && group === 'tp')"
          )  {{ item.mail }}
            i.iconfont.icon-plan(v-if='campaignUser.tp.can_edit' @click="showInput('tp', index)")
</template>

<script>
import axios from 'axios'
import { format4backend } from '@/umcc/util'
import { pickBy } from 'lodash'
export default {
  components: {},
  data () {
    return {
      editIndex: -1,
      loading: false,
      campaignUser: null,

      group: '',
      inpObj: {
        mail: '',
        parent_user_id: null,
        struct_group_id: null,
        user_id: null,
        user_name: '',
        value: ''
      },
      userList: []
    }
  },
  mounted () {
    this.getCampaignUser()
  },
  computed: {
    user () {
      return this.$store.state.common.user
    }
  },
  methods: {
    getUserList () {
      axios.get('/admin/user/getUserByDept', {
        params: {
          struct_group_code: this.group
        }
      })
        .then(res => {
          this.userList = res
        })
    },
    getCampaignUser () {
      this.loading = true
      axios.get('/management/ec/getSOWUserList', {
        params: {
          sub_final_scope_id: this.$store.state.campaign.subFinalScopeId
        }
      })
        .then(res => {
          this.loading = false
          this.campaignUser = res
        })
    },
    showInput (group, num) {
      this.editIndex = num
      this.group = group
      this.inpObj = this.campaignUser[group].leader[num]
      this.getUserList()
    },
    async updateCampaignUser (group, num) {
      this.campaignUser[group].leader[num] = Object.assign(this.campaignUser[group].leader[num], this.inpObj)
      const leader = this.campaignUser[group].leader
      const params = {
        sub_final_scope_id: this.$store.state.campaign.subFinalScopeId,
        user_type: leader[0].user_type,
        sub_final_scope_user: leader.map(o => {
          const res = {
            user_id: o.user_id,
            is_deletable: o.is_deletable,
            is_visible: o.is_visible,
            audit_user_id: o.audit_user_id
          }
          return pickBy(res, v => { return v != null })
        })
      }
      try {
        await axios.post('/management/ec/updateSOWUser', format4backend(params))
        this.group = ''
        this.editIndex = -1
        this.inpObj = {
          mail: '',
          parent_user_id: null,
          struct_group_id: null,
          user_id: null,
          user_name: '',
          value: ''
        }
        this.$message.success(this.$t('更新成功'))
        this.getCampaignUser()
      } catch (err) {
        this.$message.error(this.$t('更新失败'))
      }
    }
  }
}
</script>

<style lang='stylus'>
.ec-campaign-participant
  padding-top 25px
  .card-title
    font-size 16px
    color $title-color
  .participant-items
    width 700px
    display flex
    flex-wrap wrap
    .participant-item
      width 50%
      margin-top 24px
      .inp_block .el-input
        width 200px !important
      .title
        color #999999
        margin-bottom 8px
    .iconfont.icon-plan
      margin-left 10px
      cursor pointer
    .iconfont.icon-baocun
      margin-left 10px
      cursor pointer
</style>
